import React from 'react'
import ProjectTimesheetRow from './ProjectTimesheetRow'
import withView from '../../cmn/docAutomation/withView';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormTitle from '../../../library/form/components/FormTitle';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormDialog from '../../../library/form/components/FormDialog';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel';
import { UiView, UiViewHeading, UiAction, UiViewContent } from "../../../library/layout/Index";

const ProjectTimesheet = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam:{saveAllTS:1} }}
            formStyle={{ width: '900px', height: '650px' }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Timesheet' />}
            formObject={formObject} >
            <UiView>
                <UiViewHeading>
                    <span>
                        <span className='uiBold uiSpacerL50'>
                            <FormLabel formObject={formObject} rowKey="" headerKey="tsHeader" action={{ paramName: "totalWorkingHrs" }} value="Total Working Hours (HH:MM) " />
                        </span>
                        <FormROValue format="#" className="uiSpacerL10" formObject={formObject} rowKey="" headerKey="tsHeader" action={{ paramName: "totalWorkingHrs" }} />
                    </span>
                    <UiAction>
                        <FormButton formObject={formObject} ksc="h" rowKey=""
                            action={{ actionMessage: "PleaseWait", refreshMode:"self", actionId: "refresh", actionParam: { actionType: "regenerateTS" } }}
                            className="uiActionButton" text={<SarasTrans value="Regenerate Timesheet" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Date" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Start On" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="End On" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Working Hours" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Manaul Adjusted Hours" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="No Work Done" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Reason" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Comment" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProjectTimesheetRow formObject={formObject} rowKey={row.rowKey} viewData={row}
                                    key={index} index={index + 1} />
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(ProjectTimesheet, "projectTS", "projectTS,prodHeader");